// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Element from 'element-ui'
// import './styles/element-variables.scss' // 可更改主体的样式(勿删)
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css' // 字体ICON
import './styles/index.scss' // 全局 css
import filters from './filters' // 全局过滤器
import directives from './directives' // 全局指令
import utils from './utils/install' // 全局工具类
import './permission' // 权限控制
import VueLazyload from 'vue-lazyload' // 懒加载

// 全局组件注册
import CMoney from '@/components/global/CMoney'
import CTable from '@/components/global/CTable'
import CSelect from '@/components/global/CSelect'
import CTitle from '@/components/global/CTitle'
import SelectTree from '@/components/global/SelectTree'
import CDatePicker from '@/components/global/CDatePicker'
import CQuery from '@/components/global/CQuery'
Vue.component(CMoney.name, CMoney)
Vue.component(CTable.name, CTable)
Vue.component(CSelect.name, CSelect)
Vue.component(CTitle.name, CTitle)
Vue.component(SelectTree.name, SelectTree)
Vue.component(CDatePicker.name, CDatePicker)
Vue.component(CQuery.name, CQuery)

Vue.config.productionTip = false
Vue.use(directives)
Vue.use(Element, {
    // size: 'small'
})
Vue.use(utils)
Vue.use(VueLazyload, {
    error: 'static/img/error.png', // 错误图片,
    loading: 'static/img/loading.gif', // 加载中图片
    attempt: 3 // 尝试三次
})
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js